import React from "react";
import LegalLayout, { Section, InlineLink } from "@/pages/LegalLayout";

const Terms = () => (
  <LegalLayout
    title="Obchodní podmínky"
    metaTitle="Obchodní podmínky | SANVIORO"
    description="Obchodní podmínky úklidových služeb SANVIORO (Sanvioro s.r.o., IČO 29637066). Objednávka, cena, platební podmínky, reklamace a odpovědnost."
    path="/obchodni-podminky"
  >
    <p className="text-[#333333]">
      Tyto obchodní podmínky upravují poskytování úklidových služeb pod
      značkou SANVIORO.
    </p>

    <Section title="Poskytovatel služeb">
      <ul className="space-y-1">
        <li><strong>Sanvioro s.r.o.</strong></li>
        <li>IČO: 29637066</li>
        <li>Sídlo: Příkop 843/4, Zábrdovice, 602 00 Brno, Česká republika</li>
      </ul>
    </Section>

    <Section title="Nabízené služby">
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>Pravidelný úklid kanceláří</li>
        <li>Úklid firemních prostor</li>
        <li>Úklid provozoven</li>
        <li>Úklid společných prostor domů</li>
        <li>Generální úklid</li>
        <li>Individuální úklidové služby dle dohody</li>
      </ul>
    </Section>

    <Section title="Objednávka služeb">
      <p>
        Poptávku lze zaslat prostřednictvím formuláře, e-mailu nebo
        telefonicky. Následně bude zákazníkovi zaslána individuální nabídka.
      </p>
    </Section>

    <Section title="Cena služeb">
      <p>
        Cena je stanovena individuálně dle rozsahu prací, četnosti úklidu,
        velikosti prostor a dalších požadavků klienta.
      </p>
    </Section>

    <Section title="Platební podmínky">
      <p>
        Platba probíhá na základě vystavené faktury, není-li dohodnuto jinak.
      </p>
    </Section>

    <Section title="Termíny plnění">
      <p>
        Termíny jsou sjednávány individuálně dle potřeb klienta a provozních
        možností poskytovatele.
      </p>
    </Section>

    <Section title="Odpovědnost">
      <p>
        Poskytovatel odpovídá za řádné provedení služeb v běžném rozsahu
        a dle sjednaných podmínek.
      </p>
    </Section>

    <Section title="Reklamace">
      <p>
        Případné reklamace je nutné oznámit bez zbytečného odkladu na
        e-mail{" "}
        <InlineLink external to="mailto:info@sanvioro.cz">
          info@sanvioro.cz
        </InlineLink>
        .
      </p>
    </Section>

    <Section title="Závěrečná ustanovení">
      <p>
        Tyto podmínky mohou být průběžně aktualizovány. Více informací o nás
        najdete na stránce <InlineLink to="/o-nas">O nás</InlineLink>.
        Zpracování osobních údajů upravují{" "}
        <InlineLink to="/ochrana-osobnich-udaju">
          zásady ochrany osobních údajů
        </InlineLink>
        .
      </p>
    </Section>
  </LegalLayout>
);

export default Terms;
